module.exports = __webpack_public_path__ + "3dbe683fb3d8d07aba0cc901ad694d7c.svg";